import { Typography } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import { ArrowForward } from "@mui/icons-material"
import React from "react"
import styled, { keyframes } from "styled-components"

const entranceAnim = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`
const TextWrap = styled.div`
  text-align: center;
  padding: 0.5rem;
  animation: ${entranceAnim} 1s forwards;
`

const PrefixLabel = styled.span`
  font-size: 1rem;
  text-transform: uppercase;
  margin: 0;
  opacity: 0.8;
`

interface IStatModuleProps {
  /**
   * Sparkline component
   */
  children: React.ReactNode
  /**
   * Make up arrow red, and down green
   * @default false
   */
  invertArrowColor: boolean
  /**
   * The value to show underneath the Sparkline component.
   */
  value: number
  /**
   * Momentum arrow direction.
   */
  valueDirection: "up" | "down" | null
  /**
   * The title to show underneath the value, to give it some context.
   */
  valueTitle: string
  /**
   * Additional text line to show underneath value and title.
   * @default ""
   */
  valueSubtitle: string
  /**
   * Value prefix
   * @default ""
   */
  valuePrefix: string
  /**
   * Value suffix
   * @default ""
   */
  valueSuffix: string
}

export default function StatModule({
  children,
  invertArrowColor = false,
  value,
  valueDirection,
  valueTitle = "",
  valueSubtitle = "",
  valuePrefix = "",
  valueSuffix = ""
}: IStatModuleProps) {
  const theme = useTheme()
  const valueDirectionIcon = valueDirection ? (
    <ArrowForward
      style={{
        transform: `rotate(${valueDirection === "up" ? "-45deg" : "45deg"})`,
        color:
          valueDirection === "up" && !invertArrowColor
            ? theme.palette.success.main
            : theme.palette.error.main
      }}
    />
  ) : null
  return (
    <div>
      {children}
      <TextWrap>
        {!isNaN(value) ? (
          <>
            {valueDirectionIcon}
            <Typography variant="h2">
              {valuePrefix ? <PrefixLabel>{valuePrefix}</PrefixLabel> : null}
              {value}
              {valueSuffix ? <PrefixLabel>{valueSuffix}</PrefixLabel> : null}
            </Typography>
          </>
        ) : (
          ""
        )}
        {valueTitle ? <Typography variant="h4">{valueTitle}</Typography> : ""}
        {valueSubtitle ? (
          <Typography variant="overline">{valueSubtitle}</Typography>
        ) : (
          ""
        )}
      </TextWrap>
    </div>
  )
}
